module.exports = {
  ALGOLIA_INDEX   : "clawson_search_production",
  ALGOLIA_APP_ID  : "KH283DNHYF",
  ALGOLIA_API_KEY : "fea66231fa39a1c8326ac94f0252a75c",
}
